import _ from 'underscore';

// allow feature name for entity name filter
export const allowedEntityNameFilterFeatureName = ['CampaignsGrid'];

export const entityNameFilterType = _.reduce(allowedEntityNameFilterFeatureName, (memo, featureName) => _.extend(memo, { [featureName]: `EntityNameFilter_${featureName}` }), {});

export const featureNameToEntityNameFilter = entityNameFilterType;
